import { useLocation, useNavigate } from 'react-router'

import { SidebarList } from '@weberlo/components'

import MiniDrawer from '../MiniDrawer'

import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import {
  Activity,
  Conversion,
  //Journey,
  Reports,
  Settings,
  Setup,
} from 'assets/icons'

const Navigation = ({ open }: Props) => {
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname

  const setupParentSelected =
    path.includes('/setup') ||
    path.includes('/developer') ||
    path.includes('/shopify') ||
    path.includes('/bigcommerce') ||
    path.includes('/paypal') ||
    path.includes('/facebook_ads') ||
    path.includes('/woocommerce') ||
    path.includes('/thrivecart') ||
    path.includes('/clickfunnels') ||
    path.includes('/kajabi') ||
    path.includes('/stripe') ||
    path.includes('/google_ads') ||
    path.includes('/bing') ||
    path.includes('/tiktok_ads') ||
    path.includes('/webhooks') ||
    path.includes('/linkedin')

  const listItems = [
    {
      title: 'Reports',
      icon: <Reports />,
      link: '/reports/overview',
      isSelected:
        location.pathname.includes('/reports') ||
        location.pathname === '/reports/customers' ||
        location.pathname === '/reports/journey',
      subItems: [
        {
          title: 'Overview',
          link: '/reports/overview',
          isSelected: location.pathname === '/reports/overview',
        },
        {
          title: 'Channels',
          link: '/reports/traffic/channels',
          isSelected: location.pathname.includes('/reports/traffic/channels'),
        },
        {
          title: 'Ads Manager',
          link: '/reports/traffic/ads',
          isSelected: location.pathname.includes('/reports/traffic/ads'),
        },
        {
          title: 'Organic',
          link: '/reports/traffic/organic',
          isSelected: location.pathname.includes('/reports/traffic/organic'),
        },
        {
          title: 'Page Performance',
          link: '/reports/traffic/pages',
          isSelected: location.pathname.includes('/reports/traffic/pages'),
        },
        {
          title: 'LTV Cohort',
          link: '/reports/customers',
          isSelected: location.pathname === '/reports/customers',
        },
        {
          title: 'Journey Map',
          link: '/reports/journey',
          isSelected: location.pathname === '/reports/journey',
        },
      ],
    },
    {
      title: 'AI Agent',
      icon: <SmartToyOutlinedIcon sx={{ fontSize: 22 }} />,
      link: '/ai',
      isSelected: path === '/ai',
    },
    {
      title: 'Activity',
      icon: <Activity />,
      link: '/activity',
      isSelected: location.pathname.includes('/activity'),
    },
    {
      title: 'Conversions',
      icon: <Conversion />,
      link: '/conversions/forms',
      isSelected: location.pathname.includes('/conversions'),
    },
    // {
    //   title: 'Journey',
    //   icon: <Journey />,
    //   link: '/journey',
    //   isSelected: location.pathname.includes('/journey'),
    // },
    {
      title: 'Setup',
      icon: <Setup />,
      link: '/setup/tracking',
      isSelected: setupParentSelected,
      subItems: [
        {
          title: 'Tracking Code',
          link: '/setup/tracking',
          isSelected: path === '/setup/tracking',
        },
        {
          title: 'Integrations',
          link: '/setup/apps',
          isSelected: path === '/setup/apps',
        },
        {
          title: 'API',
          link: '/developer/api',
          isSelected: path === '/developer/api',
        },
        {
          title: 'Custom Domains',
          link: '/setup/domain',
          isSelected: path === '/setup/domain',
        },
        {
          title: 'Blacklist',
          link: '/setup/blacklist',
          isSelected: path === '/setup/blacklist',
        },
        {
          title: 'Channels',
          link: '/setup/channels',
          isSelected: path === '/setup/channels',
        },
      ],
    },
    {
      title: 'Settings',
      icon: <Settings />,
      link: '/settings/general',
      isSelected: path.includes('/settings'),
      subItems: [
        {
          title: 'General',
          link: '/settings/general',
          isSelected: path === '/settings/general',
        },
        {
          title: 'Users',
          link: '/settings/users',
          isSelected: path === '/settings/users',
        },
        {
          title: 'Notifications',
          link: '/settings/notifications',
          isSelected: path === '/settings/notifications',
        },
        {
          title: 'Billing',
          link: '/settings/billing',
          isSelected: path === '/settings/billing',
        },
        {
          title: 'Plan',
          link: '/settings/plan',
          isSelected: path === '/settings/plan',
        },
      ],
    },
  ]

  const onClickRoute = (route: string) => {
    navigate(route, { replace: true })
  }

  if (!open) {
    return (
      <MiniDrawer
        listItems={listItems}
        onClickRoute={onClickRoute}
      />
    )
  }

  return (
    <SidebarList
      headerTitle=""
      listItems={listItems}
      onClickRoute={onClickRoute}
    />
  )
}

interface Props {
  open: boolean
}

export default Navigation
